// Thuế suất theo loại dịch vụ khi tách
export const SERVICE_TAX_RATES: Record<string, { vat: number; tndn: number; name: string }> = {
    '1': { vat: 5, tndn: 5, name: 'Thương mại, mua bán theo điều khoản Incoterm' },
    '2': { vat: 5, tndn: 5, name: 'Cho thuê máy móc thiết bị, Bảo hiểm, Bảo hành, bảo dưỡng, Dịch vụ thiết kế, Dịch vụ giám sát, Hướng dẫn lắp đặt, Dịch vụ đào tạo kỹ thuật, Vận hành thử, Dịch vụ khác' },
    '3': { vat: 5, tndn: 5, name: 'Sản xuất, Dịch vụ có gắn với hàng hóa' },
    '4': { vat: 5, tndn: 2, name: 'Xây dựng, lắp đặt có bao thầu nguyên vật liệu, máy móc, thiết bị' },
    '5': { vat: 5, tndn: 5, name: 'Xây dựng, lắp đặt không bao thầu nguyên vật liệu, máy móc, thiết bị' },
    '6': { vat: 5, tndn: 5, name: 'Hoạt động kinh doanh khác' },
}

export const NT_KHONG_TACH_VAT = 3

export const NT_KHONG_TACH_TNDN = 2